// Official X (formerly Twitter) brand glyph.
// Path data from the 2023 X branding refresh — square 1200x1227 viewBox normalised to 24.
export default function XIcon({ size = 16, className = "", ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      className={className}
      {...rest}
    >
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24h-6.667l-5.218-6.815-5.973 6.815H1.66l7.73-8.835L1.255 2.25h6.835l4.713 6.231Zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77Z" />
    </svg>
  );
}
